import React, {FC} from 'react'
import {useAppDispatch} from 'redux/config'
import {useSelector} from 'react-redux'
import {customMessageRequest} from 'redux/toast/toast.duck'
import {select_totals_showFilters, select_gridSession_filters_areDirty} from 'redux/totals/selectors'
import {fetchHomeStats, fetchTotals, TotalsAC} from 'redux/totals/totals.duck'
import {Button, Icon, Stack} from '@mdsol/onex-design'

import FiltersPanel from './FiltersPanel'

const HomeControl: FC = () => {
  const dispatch = useAppDispatch()

  const showFilters = useSelector(select_totals_showFilters)
  const areFiltersDirty = useSelector(select_gridSession_filters_areDirty)

  const filtersShowClass = 'onex-btn--icon onex-btn--filled onex-btn--default'
  const filtersHideClass = filtersShowClass + ' onex-btn--indicator onex-btn--indicator--unread'

  const filtersButtonClass = !showFilters && areFiltersDirty ? filtersHideClass : filtersShowClass

  const toggleFilters = () => {
    dispatch(TotalsAC.showFiltersToggled())
  }

  const handleRefresh = () => {
    dispatch(TotalsAC.hydrateApplied(false))

    dispatch(TotalsAC.homeStatsReset())
    dispatch(fetchTotals())
    dispatch(fetchHomeStats())

    dispatch(customMessageRequest('information', 'Totals data has been refreshed.', 1000))
  }

  return (
    <>
      <div className='onex-data-grid-control'>
        <div className='onex-data-grid-control__actions'>
          <Stack className='buttons-panel' direction='horizontal' gap={2}>
            <Button
              dataTestId='home-stats-refresh-button'
              size='sm'
              leadingIcon={<Icon key='key-jobs-filters-panel-refresh-leading-icon'>refresh</Icon>}
              onClick={handleRefresh}
            >
              Refresh
            </Button>

            <Button
              dataTestId='filters-toggle-button'
              onClick={toggleFilters}
              className={filtersButtonClass}
              variant='secondary'
            >
              <Icon>filter_alt</Icon>
              <Icon>{showFilters ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</Icon>
            </Button>
          </Stack>
        </div>
      </div>

      {showFilters && <FiltersPanel />}
    </>
  )
}

export default HomeControl
